var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M20.6125 10.1201C20.7575 20.1927 2.6965 24.2507 0.738501 10.1201C0.665741 0.0474577 18.654 -4.01052 20.6125 10.1201Z",
    fill: "#2C5B47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9545 11.4972C14.8818 11.2073 15.1723 9.17839 14.8095 8.09142C14.374 7.58416 13.5766 6.78704 12.6333 5.91747C10.9653 5.77257 8.71676 5.70006 6.61324 5.91747C6.17818 8.09142 6.3232 12.0768 6.54097 14.1058C9.29732 14.4682 10.8203 14.4682 14.9545 14.1058V13.2363V13.3812V11.4972ZM10.6752 12.7291C10.5302 12.7291 10.0947 12.7291 9.73238 12.4393C9.36959 12.077 9.07955 11.4972 9.29732 10.9175C9.44234 10.4102 9.95015 10.0478 10.5302 10.0478C11.038 10.0478 11.5454 10.3376 11.6909 10.8449C11.9086 11.2073 11.9809 11.7145 11.6909 12.1493C11.4008 12.729 10.7475 12.7291 10.6752 12.7291ZM11.9809 8.38116C11.5454 8.45367 9.87739 8.38116 7.48384 8.38116V6.93188C8.78902 6.85937 9.36958 6.93188 11.8354 6.93188C11.9082 7.07678 11.9077 7.00427 12.0532 7.22167C11.9804 7.65648 12.1259 7.5116 11.9809 8.38116Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.9c5e3f6178c82d7b68d43f19f05938e8.svg";
export { ForwardRef as ReactComponent };